import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';
import SignUpLink from './SignUpLink';

export default function FreeTrialBanner() {
  const { t } = useI18n();
  const { freeTrial } = useBookersContent();
  const trial = freeTrial;

  return (
    <section className="bg-[#0b0b0f] text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-14 md:py-20">
        <div className="reveal grid lg:grid-cols-[1.5fr_1fr] gap-10 items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-[#a99bff]">
              <Sparkles size={13} /> {trial.eyebrow}
            </span>
            <h2 className="font-display text-3xl md:text-5xl mt-5 max-w-2xl">{trial.title}</h2>
            <p className="text-white/60 mt-4 text-lg max-w-xl">{trial.text}</p>
            <SignUpLink className="btn-pill mt-8 px-7 py-3.5 text-[15px] bg-white text-[#0b0b0f] hover:bg-white/90 font-semibold group inline-flex items-center gap-2">
              {trial.cta} <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
            </SignUpLink>
          </div>

          <div className="rounded-[2rem] bg-white/[0.05] border border-white/10 p-10 text-center">
            <p className="font-display text-7xl md:text-8xl bg-gradient-to-br from-white to-[#a99bff] bg-clip-text text-transparent">{trial.highlightValue}</p>
            <p className="text-white/70 mt-2 text-lg">{trial.highlightLabel}</p>
            <p className="text-white/40 text-sm mt-4">{t('freeTrial.noCard')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
